export const TIPO_CORSO = {
    PRESENZA: "Presenza",
    TELEMATICA_SINCRONA: "Telematica_Sincrona",
    TELEMATICA_ASINCRONA: "Telematica_Asincrona",
    TELEMATICA_MISTA: "Telematica_Mista",
    MISTA_PRESENZA_TELEMATICA: "Mista_Presenza/Telematica"
}
